<template>
  <Teleport to="body">
    <transition name="fade">
    <div class="popup popup_big" v-show="showPopup">  <!-- if only mobile - add class "visible-mobile"-->
      <div class="modalContent">
        <div class="closeBlock">
          <i class="close" @click="closePopup()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L12 10.5858L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L10.5858 12L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L12 13.4142L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L13.4142 12L18.7071 6.70711Z" fill="#526C82" fill-opacity="0.8"/>
            </svg>
          </i>
        </div>
        <form class="helpForm helpForm_renew" @submit.prevent="onSubmit()">
          <div class="modal_titleForm">{{ $t('contact_us_popup_header') }}</div>
          <div class="helpDesc">{{ $t('contact_us_popup_leave_phone') }}</div>
          <div class="group-popup">
            <BaseInputPhone
              :error="$v.phoneInfo.phone.$dirty && $v.phoneInfo.phone.$invalid"
              :default-country-code="phoneInfo.countryCode"
              v-model="phoneInfo.phone"
              @update="onUpdatePhone"
              inputMode="mini"/>
            <button class="btn" type="submit">
              {{ $t('qic_send') }}
            </button>
          </div>
          <div class="reminder">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.17157 4.17157C9.92172 3.42143 10.9391 3 12 3C13.0609 3 14.0783 3.42143 14.8284 4.17157C15.5786 4.92172 16 5.93913 16 7V10H8V7C8 5.93913 8.42143 4.92172 9.17157 4.17157ZM6 10V7C6 5.4087 6.63214 3.88258 7.75736 2.75736C8.88258 1.63214 10.4087 1 12 1C13.5913 1 15.1174 1.63214 16.2426 2.75736C17.3679 3.88258 18 5.4087 18 7V10H19C20.6569 10 22 11.3431 22 13V20C22 21.6569 20.6569 23 19 23H5C3.34315 23 2 21.6569 2 20V13C2 11.3431 3.34315 10 5 10H6ZM17 12H7H5C4.44772 12 4 12.4477 4 13V20C4 20.5523 4.44772 21 5 21H19C19.5523 21 20 20.5523 20 20V13C20 12.4477 19.5523 12 19 12H17Z" fill="#526C82" fill-opacity="0.8"/>
          </svg>
          {{ $t('qic_need_help_popup_reminder') }}
        </div>
          <div class="or"></div>
          <div class="or-phone">{{ $t('contact_us_popup_we_can_help') }}</div>
          <div class="helpForm__btn-group">
            <a :href="whatsapUrl" target="_blank" class="btnWhatsapp">
              <i class="wa"></i> {{ $t('qic_need_help_popup_wa_chat') }}
            </a>
            <a href="tel:8000742" class="btn btn-second btn-second_medium">{{ $t('contact_us_popup_hotline') }}</a>
          </div>

        </form>

      </div>
    </div> <!-- popup -->
    </transition>
    <transition name="fade">
    <div class="popup popupSmall" v-show="showSentPopup">  <!-- if only mobile - add class "visible-mobile"-->
      <div class="modalContent">
        <i class="close" @click="closePopup()"></i>
        <div class="acceptModal">
          <div class="modal_titleForm">
            {{ $t('qic_need_help_sent_popup_header') }}
          </div>
          <div class="modal_descForm">
            {{ $t('qic_need_help_sent_popup_message') }}
          </div>
          <button class="btn btnAccept" type="button" @click="closePopup()">
            {{ $t('qic_ok') }}
          </button>
        </div>
      </div>
    </div> <!-- popup -->
    </transition>
    <transition name="fade">
    <div class="bgPopup"  v-show="showPopupBg"  @click="closePopup()"></div> <!-- if only mobile - add class "visible-mobile"-->
    </transition>
  </Teleport>
</template>

<script>
import { BaseInputPhone } from 'qic-components'
import Teleport from 'vue2-teleport'
export default {
  name: 'ContactUsPopup',
  props: [
    'value'
  ],
  emits: [
    'close'
  ],
  components: {
    BaseInputPhone,
    Teleport
  },
  inject: {
    needHelpPhoneCode: { default: 'QA' },
    needHelpWhatsapNumber: { default: '97451047909' }
  },
  computed: {
    sendDisabled () {
      return this.$v.$invalid
    },
    showPopup () {
      return this.value && !this.showSent
    },
    showSentPopup () {
      return this.value && this.showSent
    },
    showPopupBg () {
      return this.value
    },
    whatsapUrl () {
      return `https://api.whatsapp.com/send/?phone=${this.needHelpWhatsapNumber}&text&app_absent=0`
    }
  },
  data () {
    return {
      phoneInfo: {
        countryCode: this.needHelpPhoneCode,
        phone: '',
        formattedPhone: '',
        isValidLength: false
      },
      showSent: false
    }
  },
  methods: {
    closePopup () {
      this.$emit('input', false)
      this.$emit('close')
    },
    async onSubmit () {
      this.$v.$touch()
      if (this.sendDisabled) return
      try {
        await this.$store.dispatch('sendCallback', {
          phone: this.phoneInfo.formattedPhone
        })
      } catch {
        this.showSent = true
      }
      this.showSent = true
      // this.$emit('close')
    },
    onUpdatePhone (result) {
      this.phoneInfo.formattedPhone = result?.formattedNumber()
      this.phoneInfo.isValidLength = result?.isValidLength()
      this.phoneInfo.countryCode = result?.countryCode
      this.$v.$reset()
    }
  },
  validations () {
    return {
      phoneInfo: {
        phone: {
          validPhone: () => {
            return this.phoneInfo.isValidLength
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .15s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
  transition: opacity .05s;
}
</style>
